import { render } from "./newDistpatch.vue?vue&type=template&id=a042b7d2"
import script from "./newDistpatch.vue?vue&type=script&lang=js"
export * from "./newDistpatch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__